import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSpaces } from '../providers';

const NewSpace = () => {
  const navigate = useNavigate();
  const { createSpace } = useSpaces();

  useEffect(() => {
    const createSpaceAndRedirect = async () => {
      const space = await createSpace('New space', false);

      return navigate(`/spaces/${space.id}`, { state: { editTitle: true } });
    };

    createSpaceAndRedirect();
  }, []);

  return null;
};

export { NewSpace };
